// Fixed layout dimensions for the app shell. Exposed on the theme (theme.layout)
// because the rail/sidebar widths are referenced by more than one component.
export const layout = {
  iconRailWidth: 64,
  sidebarWidth: 280, // default expanded width; drag the right edge to resize (long titles clip until widened)
  promptMaxWidth: 860,
  homeMaxWidth: 920,
  conversationMaxWidth: 760, // the conversation column, and the detection card drawn alone before a chat exists
} as const;

export type AppLayout = typeof layout;
